module.exports = __webpack_public_path__ + "45b65c1cafd0741f123370845204e554.jpg";